/**
 * Filters the reference cards by the branch in the URL hash, and marks the
 * matching branch button as active. Was jQuery, is not any more.
 *
 * No stylesheet import here on purpose: this entry is loaded next to the app
 * entry, and importing web.scss again would emit the whole stylesheet twice.
 */

const SHOW_ALL = 'all';

const setHidden = (element: HTMLElement, hidden: boolean): void => {
    element.style.display = hidden ? 'none' : '';
};

const filterReferences = (): void => {
    // Branch on the raw hash, not on the resolved value: '#all' is a real target
    // (the "show all" button and the "All" tab both point at it) and must run the
    // reveal below, whereas an empty hash is the untouched initial state that
    // must not. Resolving to SHOW_ALL first would collapse those two into one.
    const hash = window.location.hash.slice(1);
    const selected = hash || SHOW_ALL;

    // With a filter engaged, every card becomes a candidate: the ones the server
    // rendered collapsed are un-collapsed first, and the "show all" button goes,
    // since the branch buttons already offer that.
    if (hash !== '') {
        for (const card of document.querySelectorAll<HTMLElement>('.references-to-filter .reference.d-none')) {
            card.classList.remove('d-none');
        }

        const showAll = document.querySelector<HTMLElement>('#referenceShowAll');
        if (showAll) {
            setHidden(showAll, true);
        }
    }

    for (const card of document.querySelectorAll<HTMLElement>('.references-to-filter .reference')) {
        const branches = card.dataset.branch ?? '';
        setHidden(card, selected !== SHOW_ALL && !branches.includes(selected));
    }

    for (const button of document.querySelectorAll<HTMLElement>('.reference-branch-selector-button')) {
        const active = button.dataset.branche === selected;
        button.classList.toggle('btn-primary', active);
        button.classList.toggle('btn-outline-primary', !active);
    }
};

window.addEventListener('hashchange', filterReferences);

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', filterReferences);
} else {
    filterReferences();
}
